// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"30":"83f45bb8f2b4c75f8a18","489":"89211c216fb1a5be2054"}[chunkId] + ".js";
};